import React from "react";
import FAQAccordion from '../FAQAccordion';

class AcadiaNationalParkInfo extends React.Component {
  render() {
    return (
      <React.Fragment>
        <section className="about-us pt-trip">
          <div className="container">

            <p>
              Acadia National Park in Maine is the crown jewel of the New England coast — a granite headland where mountains meet the Atlantic, tide pools dot rocky shores, and Cadillac Mountain catches the first sunrise in the continental United States from October through March. It's compact, spectacular, and endlessly photogenic.
            </p>
            <p>
              The park sits mostly on Mount Desert Island, connected to the mainland town of Bar Harbor by a short causeway. Bar Harbor is the base for most visitors: a charming coastal town with lobster rolls, whale-watching tours, and a buzzy main street. From here, every major park highlight is within 30 minutes.
            </p>

            <div className="xinfo-card">
              <div className="xinfo-card-body">
                <p className="xinfo-card-label">Must-Do Experience</p>
                <h3 className="xinfo-card-title">Jordan Pond House Popovers</h3>
                <p className="xinfo-card-price">~$12 for popovers & tea</p>
                <p className="xinfo-card-desc">
                  A tradition since 1895. The Jordan Pond House serves warm popovers with butter and strawberry jam on a lawn overlooking the glassy pond and The Bubbles — two perfectly round glacial hills. Come for afternoon tea after the Jordan Pond Loop trail. Reserve ahead in summer as it fills up fast.
                </p>
              </div>
            </div>

            <h2>Acadia National Park Trip Overview</h2>
            <ul>
              <li><strong>Duration:</strong> 3 days</li>
              <li><strong>Base town:</strong> Bar Harbor, ME</li>
              <li><strong>Entry fee:</strong> $35/vehicle (7-day pass)</li>
              <li><strong>Best months:</strong> June–October; October for fall foliage</li>
              <li><strong>Drive from Boston:</strong> ~5 hours · Portland ME: ~3 hours</li>
            </ul>

            <h2>Day 1 — Sand Beach, Thunder Hole & Ocean Path</h2>
            <p>
              Arrive in Bar Harbor, check in, and head straight to the Park Loop Road. Start at <strong>Sand Beach</strong> — one of the few sandy beaches on the Maine coast, hemmed in by pink granite cliffs. The water is cold even in August (~55°F), but a quick dip is a rite of passage.
            </p>
            <p>
              Walk the <strong>Ocean Path</strong> (4.4 miles round trip, easy) south toward <strong>Thunder Hole</strong>, a natural rock chasm where waves crash and shoot air up to 40 feet into the air. Best at mid-tide on a rough sea day. Continue to Otter Cliffs — 110-foot granite sea cliffs and one of the most dramatic viewpoints in the park.
            </p>

            <h2>Day 2 — Cadillac Mountain Sunrise & Carriage Roads</h2>
            <p>
              Set your alarm for 3:30am. Drive up Cadillac Mountain (the highest point on the eastern seaboard at 1,530 ft) to catch the first sunrise in the continental US from October through March. The timed entry reservation system is required May–October — book via recreation.gov weeks in advance.
            </p>
            <p>
              After sunrise and breakfast back in Bar Harbor, rent bikes and explore the <strong>carriage roads</strong> — 45 miles of crushed-stone paths built by John D. Rockefeller Jr. in the early 1900s, entirely car-free. The Jordan Pond loop is the classic route (3.5 miles, flat). Finish the afternoon at Jordan Pond House for the famous popovers.
            </p>

            <h2>Day 3 — Bass Harbor Lighthouse & Acadia Mountain</h2>
            <p>
              Drive to the quieter western side of Mount Desert Island for the iconic <strong>Bass Harbor Head Lighthouse</strong> — the only lighthouse in Acadia, perched on pink granite boulders with the Atlantic crashing below. Best photographed at sunset. The walk to the viewing platform is less than 0.5 miles.
            </p>
            <p>
              Before heading home, hike <strong>Acadia Mountain Trail</strong> (2.5 miles, moderate) for views of Somes Sound — the only true fjord on the east coast of the US. Then grab a lobster roll in Bar Harbor for the road.
            </p>

            <h2>Getting Around Acadia</h2>
            <p>
              The free <strong>Island Explorer bus</strong> runs late June through Columbus Day, connecting Bar Harbor, the Village Green, and all major trailheads. It runs on biodiesel and is surprisingly convenient — leave your car at the hotel and take the bus to Sand Beach, the Visitors Center, and Cadillac Mountain base. Highly recommended in peak summer to avoid parking headaches.
            </p>

            <FAQAccordion
              title="Acadia National Park FAQs"
              items={[
                { q: 'Do I need a timed entry reservation for Cadillac Mountain?', a: 'Yes, from late May through October. Reservations open 90 days in advance on recreation.gov and sell out quickly for sunrise slots. The rest of the day is first-come, first-served.' },
                { q: 'What is the best hike in Acadia National Park?', a: 'The Precipice Trail (1.6 miles, strenuous — iron rungs and ladders) and Beehive Trail (1.4 miles) are the most exciting. For a classic moderate hike, the Jordan Pond Loop is beautiful and accessible.' },
                { q: 'Can you swim at Acadia National Park?', a: 'Yes — Sand Beach is the main swimming beach, though the Atlantic water is very cold (50–60°F even in summer). Echo Lake on the western side of the island is warmer and popular with families.' },
                { q: 'When does Acadia National Park get crowded?', a: 'July and August are peak season. Mid-September through mid-October is ideal — smaller crowds, beautiful fall foliage, and cooler hiking weather. Avoid Fourth of July weekend.' },
                { q: 'Is Acadia good for families with kids?', a: "Absolutely. The carriage roads are perfect for family biking, the Jordan Pond path is stroller-friendly, and Thunder Hole is endlessly entertaining for children. The Island Explorer bus makes it easy to get around without car seats." },
                { q: 'Where should I stay for Acadia National Park?', a: 'Bar Harbor is the main town — walkable, full of restaurants, and very convenient. Book 6+ months ahead for summer stays. Cheaper options are in Ellsworth (30 min away) or Southwest Harbor on the quieter side of the island.' },
              ]}
            />

          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default AcadiaNationalParkInfo;
